/**
 * @module Auction
 */
import {getField, updateField} from 'vuex-map-fields';
import {mixin} from '../../helpers/helper'

export default {
    mixins: [mixin],
    namespaced: true,
    state: {
        triggerForAuctionIncome: false, // triggering update topcard in auction operation after update data with modal (/auction_operation)
        regionCode: '',
        city: '',
        city_id: 0,
        showMapCard: true,
        showAuctionPartialArchiveCard: false,
        showAuctionPartialArchiveByCityCard: false,
        showAuctionCard: false,
        showAuctionListCard: false,
        showOverViewCard: true,
        showAuctionData: false,
        auctionArchiveData: [],
        auctionArchiveByCityData: [],
        cityData: [],
        regionData: [],
        myErrors: [],
        formData: [],
        activeGreen: '',
        activeYellow: '',
        activeGrey: '',
        activeRed: '',
        activeAll: 'active',
        color: 0,

        saveOk: false,
        showModal: false,
        editMode: false,
        readModeCSS: 'abtg__row-readmode',
        groupByRegion: [],

        showModalUpload: false,
        myFileUpload: null,
        myDescriptionUpload: null,
        myFileIdUpload: null,
        fileList: [],
        imagesList: [],
        countImages: 0,
        fileId: null,
        fileData: [],

        operationId: 0,
        auctionId: 0,

        incomeData: [],


        bread_list: [],
        bread_active: {'label': 'Nuova Operazione'},
        rating: {
            storeModule: 'auction',
            questionRate: '<strong>Valuta</strong> l\'inserimento dati asta',
            section: 'Dati asta',
            showHideModalRating: false,
        },
        closedOperation: false,
        idToDelete: 0,
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,

        closeOperationSet: function (state, boolean) {
            state.closedOperation = boolean;
        },

        offArchiveMap: function (state) {

            state.showArchive = false;
        },

        groupByRegionSet: function (state, data) {
            state.groupByRegion = data;
        },
        onOffEditModeSet: function (state, boolean) {
            state.editMode = boolean;
            if (boolean === true) {
                state.readModeCSS = '';
            } else {
                state.readModeCSS = 'abtg__row-readmode';
            }
        },

        regionCodeSet: function (state, data) {
            state.regionCode = data;
        },
        auctionStepOne: function (state) {
            state.showMapCard = true;
            state.showAuctionCard = false;
            state.showAuctionListCard = false;
            state.showAuctionPartialArchiveCard = false;
            state.showOverViewCard = true;
        },
        auctionStepTwo: function (state) {
            state.showMapCard = false;
            state.showAuctionCard = false;
            state.showAuctionListCard = true;
            state.showAuctionPartialArchiveCard = true;
            state.showOverViewCard = false;

        },
        auctionStepThree: function (state) {
            state.showMapCard = false;
            state.showAuctionCard = true;
            state.showAuctionPartialArchiveCard = true;
            state.showAuctionListCard = true;

        },
        cityDataSet: function (state, data) {
            state.cityData = data;
        },

        regionDataSet: function (state, data) {
            state.regionData = data;
        },
        singleRegionSet: function (state, data) {
            state.formData = {
                regione: data
            }
        },
        myErrors: function (state, data) {
            state.myErrors = data;
        },
        saveOkSet: function (state, boolean) {
            state.saveOk = boolean;
        },
        auctionArchiveDataSet: function (state, data) {
            state.auctionArchiveData = data;
        },
        auctionArchiveByCityDataSet: function (state, data) {
            state.auctionArchiveByCityData = data;
        },
        editAuctionSet: function (state, data) {

            state.formData = {
                indirizzo: data.indirizzo,
                city_id: data.city_id,
                rge: data.rge,
                valore_ctu: data.valore_ctu,
                mq: data.mq,
                n_incanto: data.n_incanto,
                base_asta: data.base_asta,
                offerta_minima: data.offerta_minima,
                rendita_catastale: data.rendita_catastale,
                data_asta: data.data_asta,
                reg_urbanistica: data.reg_urbanistica,
                n_creditori: data.n_creditori,
                stato_occupazionale: data.stato_occupazionale,
                valore_immobiliare_it: data.valore_immobiliare_it,
                valore_borsino_immobiliare: data.valore_borsino_immobiliare,
                street_price: data.street_price,
                agenzia_1: data.agenzia_1,
                agenzia_2: data.agenzia_2,
                agenzia_3: data.agenzia_3,
                riferimenti_custode: data.riferimenti_custode,
                note: data.note,
                stralciabile: data.stralciabile,
                color: data.color,
                id: data.id,
                regione: data.regione,
                city: data.city,
                link: data.link,
            };

        },
        citySet: function (state, data) {
            state.city = data.city;
            state.city_id = data.city_id;
        },
        formDataSpaceSet: function (state) {
            state.formData = {
                indirizzo: ' ',
                rge: ' ',
                valore_ctu: ' ',
                mq: ' ',
                n_incanto: ' ',
                base_asta: ' ',
                rendita_catastale: ' ',
                reg_urbanistica: ' ',
                n_creditori: ' ',
                stato_occupazionale: ' ',
                riferimenti_custode: ' ',
                note: ' ',
                stralciabile: ' '
            }
        },
        showModalUploadSet: function (state) {
            state.showModalUpload = !state.showModalUpload;
        },

        changeTabSet: function (state, color) {
            state.color = color;
            switch (color) {
                case 1:
                    state.activeGreen = '';
                    state.activeYellow = '';
                    state.activeGrey = '';
                    state.activeRed = 'active';
                    state.activeAll = '';
                    break;
                case 2:
                    state.activeGreen = '';
                    state.activeYellow = 'active';
                    state.activeGrey = '';
                    state.activeRed = '';
                    state.activeAll = '';
                    break;
                case 3:
                    state.activeGreen = '';
                    state.activeYellow = '';
                    state.activeGrey = 'active';
                    state.activeRed = '';
                    state.activeAll = '';
                    break;
                case 4:
                    state.activeGreen = 'active';
                    state.activeYellow = '';
                    state.activeGrey = '';
                    state.activeRed = '';
                    state.activeAll = '';
                    break;
                case 0:
                    state.activeGreen = '';
                    state.activeYellow = '';
                    state.activeGrey = '';
                    state.activeRed = '';
                    state.activeAll = 'active';
                    break;
            }
        },

        fileListSet: function (state, data) {
            state.fileList = data.docs;
            state.imagesList = data.images;
            state.countImages = data.countImages;

        },
        /*
         * Setting file for modal upload to modify/delete
         */
        singleFileSet: function (state, data) {
            state.fileData = data;
        },

        operationIdSet: function (state, data) {
            state.operationId = data;
        },

        auctionIdSet: function (state, data) {
            state.auctionId = data;
        },

        getIncomeSet: function (state, data) {
            state.incomeData = data;
        },

        breadStep1Set: function (state) {
            state.bread_active = {
                'label': 'Aste Start'
            };

            state.bread_list = {
                0: {
                    'url': '/activities/dashboard',
                    'label': 'Attività'
                }
            }
        },

        breadStep2Set: function (state) {
            state.bread_active = {
                'label': 'Gestione Aste'
            };

            state.bread_list = {
                0: {
                    'url': '/activities/dashboard',
                    'label': 'Attività'
                },
                1: {
                    'action': 1,
                    'label': 'Aste Start'
                }
            }
        },
    },

    actions: {

        /**
         * Create Auction
         * @method create
         * @memberOf module:Auction
         * @param void
         */
        create: function (state, regionCode) {
            state.commit('regionCodeSet', regionCode);
            axios.get('/api/v1/auction/regionList')
                .then(function (response) {
                    state.commit('regionDataSet', response.data);
                    state.commit('singleRegionSet', regionCode);
                    state.dispatch('prepareSchemaToInsert');
                }).catch(error => {
                if (error.response) {
                    state.dispatch('user/checkErrorMessage', error.response, {root: true});
                }
            });

        },

        prepareSchemaToInsert: function (state) {
            axios.get('/api/v1/cities/' + state.state.regionCode)
                .then(function (response) {
                    state.commit('cityDataSet', response.data);
                    state.dispatch('auctionByRegion');
                    state.commit('auctionStepTwo');
                    state.commit('breadStep2Set');
                }).catch(error => {
                if (error.response) {
                    state.dispatch('user/checkErrorMessage', error.response, {root: true});
                }
            });
        },

        cityList: function (state, regionCode) {
            axios.get('/api/v1/cities/' + regionCode)
                .then(function (response) {
                    state.commit('cityDataSet', response.data);
                }).catch(error => {
                if (error.response) {
                    state.dispatch('user/checkErrorMessage', error.response, {root: true});
                }
            });
        },

        clearForm: function (state) {
            for (let f in state.state.formData) {
                if (f != 'regione') {
                    state.state.formData[f] = '';
                }
            }
        },

        offMsg: function (state) {
            setTimeout(function () {
                state.commit('saveOkSet', false);
            }, 2000);

            setTimeout(function () {
                state.state.showModal = false;
            }, 2000)

        },

        auctionByRegion: function (state) {
            axios.get('/api/v1/auction/auctionByRegion/' + state.state.regionCode)
                .then(function (response) {
                    state.commit('auctionArchiveDataSet', response.data.data);
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        auctionListByCity: function (state, data) {
            axios.get('/api/v1/auction/auctionListByCity/' + data.city_id + '/' + data.color)
                .then(function (response) {

                    state.commit('citySet', {city_id: data.city_id, city: data.city});
                    state.dispatch('changeTab', data.color);
                    state.commit('auctionArchiveByCityDataSet', response.data.data);
                    state.commit('auctionStepThree');
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        editAuction: function (state, id) {
            state.commit('auctionIdSet', id);
            axios.get('/api/v1/auction/edit/' + id)
                .then(function (response) {
                    state.commit('editAuctionSet', response.data.data);
                    state.dispatch('openModal');
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        readingAuction: function (state, id) {
            state.commit('auctionIdSet', id);
            axios.get('/api/v1/auction/edit/' + id)
                .then(function (response) {
                    state.commit('editAuctionSet', response.data.data);
                    state.dispatch('isClosed');
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        isClosed: function (state) {
            axios.get('/api/v1/operation/isClosed/' + state.state.auctionId + '/2')
                .then(function (response) {
                    state.commit('closeOperationSet', response.data);
                })
        },

        goToStepTwo: function (state) {
            state.commit('auctionStepTwo');
        },

        formDataSpace: function (state) {
            state.commit('formDataSpaceSet');
        },

        sendData: function (state) {
            let formData = state.state.formData;

            axios.post('/api/v1/auction/save', {
                city_id: formData.city_id,
                regione: formData.regione,
                indirizzo: formData.indirizzo,
                rge: formData.rge,
                valore_ctu: mixin.methods.REMOVE_DOT(formData.valore_ctu),
                mq: mixin.methods.TRANSFORM_NULL_TO_ZERO(formData.mq),
                n_incanto: formData.n_incanto,
                base_asta: mixin.methods.REMOVE_DOT(formData.base_asta),
                offerta_minima: mixin.methods.REMOVE_DOT(formData.offerta_minima),
                rendita_catastale: mixin.methods.REMOVE_DOT(formData.rendita_catastale),
                data_asta: formData.data_asta,
                reg_urbanistica: formData.reg_urbanistica,
                n_creditori: mixin.methods.TRANSFORM_NULL_TO_ZERO(formData.n_creditori),
                stato_occupazionale: formData.stato_occupazionale,
                valore_immobiliare_it: mixin.methods.REMOVE_DOT(formData.valore_immobiliare_it),
                valore_borsino_immobiliare: mixin.methods.REMOVE_DOT(formData.valore_borsino_immobiliare),
                street_price: mixin.methods.REMOVE_DOT(formData.street_price),
                agenzia_1: mixin.methods.REMOVE_DOT(formData.agenzia_1),
                agenzia_2: mixin.methods.REMOVE_DOT(formData.agenzia_2),
                agenzia_3: mixin.methods.REMOVE_DOT(formData.agenzia_3),
                riferimenti_custode: formData.riferimenti_custode,
                note: formData.note,
                stralciabile: formData.stralciabile,
                color: formData.color,
                id: state.state.auctionId
            })
                .then(function (response) {
                    state.commit('changeTabSet', state.state.formData.color);
                    state.commit('saveOkSet', true);
                    state.dispatch('offMsg');
                    state.dispatch('auctionListByCity', {
                        city_id: state.state.formData.city_id,
                        color: state.state.formData.color,
                        city: response.data
                    });


                    if (state.state.auctionId != 0) {

                    } else {
                        state.dispatch('clearForm');
                    }

                    if (state.state.triggerForAuctionIncome === true) {
                        //state.dispatch('readingAuction', state.state.auctionId);
                    } else {
                        state.dispatch('auctionByRegion');
                    }

                })
                .catch(function (error) {
                    state.dispatch('errors/handleErrors', {error: error, module: 'auction/myErrors'}, {root: true});
                })
        },

        changeTab: function (state, color) {
            state.commit('changeTabSet', color);
        },

        openModal: function (state) {
            state.state.showModal = true;
        },

        closeModal: function (state) {
            state.state.showModal = false;
        },

        onOffEditMode: function (state, boolean) {
            state.commit('onOffEditModeSet', boolean);
        },

        groupByRegion: function (state) {
            axios.get('/api/v1/auction/groupByRegion')
                .then(function (response) {

                    state.commit('groupByRegionSet', response.data)
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        triggerModalUpload: function (state) {
            state.commit('showModalUploadSet');
        },

        sendUploadFile: function (state) {
            let forma = new FormData();
            forma.append('file', state.state.myFileUpload);
            forma.append('descrizione', state.state.myDescriptionUpload);
            forma.append('operazione_id', state.state.operationId);
            forma.append('id', state.state.myFileIdUpload);
            axios.post('/api/v1/custom/sendUploadFile', forma,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
                .then(function (response) {
                    state.dispatch('triggerModalUpload');
                    state.dispatch('fileList', {auctionId: state.state.auctionId});
                })
                .catch(function (error) {

                    state.dispatch('errors/handleErrors', {error: error, module: 'upload/myErrorsSet'}, {root: true});
                });
        },

        fileList: function (state, data) {
            axios.get('/api/v1/auction_income/' + data.auctionId + '/showOperation')
                .then(function (response) {
                    state.commit('operationIdSet', response.data.id);
                    state.commit('auctionIdSet', data.auctionId);
                    axios.get('/api/v1/custom/fileList/' + state.state.operationId)
                        .then(function (response) {
                            state.commit('fileListSet', response.data);
                        })
                });
        },

        removeFile: function (state) {
            axios.get('/api/v1/custom/removeFile/' + state.state.fileId)
                .then(function () {
                    state.dispatch('fileList', {auctionId: state.state.auctionId});
                })
        },

        /*
         * Retrieve file used in modal upload to modify/delete it
         */
        retrieveFile: function (state, id) {
            axios.get('/api/v1/custom/retrieveFile/' + id)
                .then(function (response) {
                    state.commit('singleFileSet', response.data);
                    state.dispatch('upload/settingFileData', state.state.fileData, {root: true});
                    state.dispatch('triggerModalUpload');
                })
        },

        offArchiveMap: function (state) {

            state.commit('breadStep1Set');
            state.commit('offArchiveMap');
        },

        breadForceStep(state, whichStep) {

            if (whichStep === 1) {
                //  state.dispatch('groupByRegion');
                state.commit('auctionStepOne');

            }
            state.commit('breadStep' + whichStep + 'Set');
        },

        openCloseRatingModal: function (state) {

            axios.post('/api/v1/rating/checkRatingDone', {
                area: state.state.rating.section
            })
                .then(function (response) {
                    if (response.data === false) {
                        state.state.rating.showHideModalRating = !state.state.rating.showHideModalRating;
                    } else {
                        state.state.rating.showHideModalRating = false;
                    }


                })
                .catch(function (error) {

                })

        },

        closeOrOpen: function (state) {
            axios.post('/api/v1/operation/close', {resourceId: state.state.auctionId, type: 2})
                .then(function (response) {
                    state.commit('closeOperationSet', response.data);
                })
        },

        deleteAllAuctionInTheCity: function (state) {
            axios.get('/api/v1/auction/deleteAllAuctionInTheCity/' + state.state.idToDelete)
                .then(function (response) {
                    state.dispatch('create', state.state.regionCode);
                    state.dispatch('auctionListByCity', {city_id: 0, color: 0})
                })
        },

        deleteSingleAuction: function (state) {
            axios.get('/api/v1/auction/deleteSingleAuction/' + state.state.idToDelete)
                .then(function (response) {
                    state.dispatch('create', state.state.regionCode);
                    state.dispatch('auctionListByCity', {city_id: state.state.city_id, color: 0})
                })
        },

        deleteAuctionsInRegion: function (state) {
            axios.get('/api/v1/auction/deleteAuctionsInRegion/' + state.state.idToDelete)
                .then(function (response) {
                    state.dispatch('groupByRegion');
                })
        },

        createOperation: function(state, id)
        {
            axios.get('/api/v1/auction/createOperation/' + id)
                .then(function(response){
                    window.location.href = '/auction_operation/detail/' + id + '/' + response.data.idOperation;
                    //window.location.href="/custom/" + response.data.idBuilding + '/' + response.data.idOperation;
                })
        },
    }
}